import { render, staticRenderFns } from "./Page_VerifyEmail.vue?vue&type=template&id=e0f09772&scoped=true&"
import script from "./Page_VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./Page_VerifyEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f09772",
  null
  
)

export default component.exports